import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const SalesPerformanceInput = () => {
  const { performanceId = '' } = useParams();
  const decodedId = performanceId ? atob(performanceId) : performanceId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'salesPerformance';

  useEffect(() => {
    if (performanceId) { setIsEditing(true); fetchDetails(); }
  }, [performanceId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['salesPerformance'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Sales Performance details:', error); }
  };

  const fields = [
    {
      name: 'sales_person', label: 'Sales Person', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    { name: 'period', label: 'Period (e.g. Q1 2025, Jan 2025)', type: 'text' },
    {
      name: 'period_type', label: 'Period Type', type: 'select',
      options: [
        { value: 'daily', label: 'Daily' },
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'quarterly', label: 'Quarterly' },
        { value: 'annual', label: 'Annual' },
      ],
    },
    { name: 'sales_date', label: 'Sales Date', type: 'date', dateConstraint: 'past' },
    { name: 'target_amount', label: 'Target Amount', type: 'number' },
    { name: 'achieved_amount', label: 'Achieved Amount', type: 'number' },
    { name: 'deals_closed', label: 'Deals Closed', type: 'number' },
    {
      name: 'region', label: 'Region', type: 'async-select',
      endpoint: API_ROUTES.salesRegion,
      getOptionLabel: (r) => r.name,
    },
    { name: 'notes', label: 'Notes', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Sales Performance' : 'Create Sales Performance'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default SalesPerformanceInput;
